import {greysDark} from '../../styles/colorStyles';

export const DARK_APP_FOREGROUND_COLOR = greysDark.shade20;
